import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Reports/hooks/useReportEntryType.ts
/**
* Get a single ReportEntryType details
*
* @param args
* @param opts
*/
function useReportEntryType(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportEntryType.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReportEntryType };

//# sourceMappingURL=useReportEntryType.js.map